import { type DataValue, NOT_FOUND, type UnitLegacy } from '@netpurpose/types'

type BackedDataValueUnit = UnitLegacy['name'] | 'NEW' | 'NOT FOUND' | 'UNPROCESSABLE'

export type BackendDataValue = [number | null, BackedDataValueUnit]

export const parseUnitName = (unit: BackedDataValueUnit) => {
  // NOT FOUND is displayed differently between control and client.
  if (unit === 'NOT FOUND') {
    return NOT_FOUND
  }
  return unit
}

export const parseDataValue = (backendDataValue: BackendDataValue): DataValue => {
  const [value, unit] = backendDataValue
  // Only a handful of very old facts have null values. Also new supporting facts
  // for product revenue segments based on earlier years, the value will be null.
  return { value: value ?? 0, unit: parseUnitName(unit) }
}

const formatUnitName = (unit: string) => (unit === NOT_FOUND ? 'NOT FOUND' : unit)

export const formatDataValue = (dataValue: DataValue): BackendDataValue => {
  const { value, unit } = dataValue
  if (value === undefined) {
    return [null, formatUnitName(unit)]
  }

  return [value, formatUnitName(unit)]
}
